import { GroupedVariableInsertMenu } from "@/components/variable-insert-menu/GroupedVariableInsertMenu.tsx";
import { PlaceholderOption } from "@/components/rich-editor/rich-editor.types.ts";
import { Select, SelectItem, SelectValueType } from "@skailer-com/uikit";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

interface VariableInsertMenuProps {
  options: PlaceholderOption[];
  onInsert: (id: string) => void;
}

export const VariableInsertMenu = ({ options, onInsert }: VariableInsertMenuProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<SelectValueType>(null);

  const items = useMemo<SelectItem[]>(
    () => options.map((option) => ({ id: option.id, title: option.title, group: option.group })),
    [options]
  );

  if (options.some((option) => option.subgroup)) {
    return <GroupedVariableInsertMenu options={options} onInsert={onInsert} />;
  }

  return (
    <Select
      variant="button"
      emptyTitle={t("common:insert") + "..."}
      searchable
      groupsAsSubmenu
      isClearable={false}
      options={items}
      value={value}
      onChange={(selected) => {
        if (!selected) return;
        onInsert(String(selected));
        setValue(null);
      }}
    />
  );
};
